import userModelReducer from '../../../modules/users/helpers/profile-model-reducer';
import scorePassword from '../../../helpers/score-password';

class ProfileEditController {

    constructor($rootScope, $http, Error, SweetAlert, $state, ResourceCommon) {
        this.rootScope = $rootScope;
        this.api = $http;
        this.errorHandler = Error;
        this.sweetAlert = SweetAlert;
        this.state = $state;
        this.resourceCommon = ResourceCommon;

        this.submitting = false;

        this.roles = this.rootScope.company.modules;
        this._loadProfile().then(() => {
            this._calculateStrength();
            this.checkPasswordMatch();
        });

    }

    checkPasswordMatch() {
        return this.passwordsMatch = (_.get(this.model, 'password', '') === _.get(this.model, 'password_confirmation', ''));
    }

    checkStrength() {
        this._calculateStrength();
    }

    _calculateStrength() {
        this.strength = scorePassword(_.get(this.model, 'password', ''));

        let classToSet;
        if (this.strength < 60) {
            classToSet = 'insecure';
        } else if (this.strength <= 80) {
            classToSet = 'ok';
        } else {
            classToSet = 'strong';
        }

        this.strengthClass = classToSet;
    }

    save() {
        if (this.submitting) {
            return;
        }
        if (this.model.password) {
            if (!this.checkPasswordMatch()) {
                this.sweetAlert.error('No Match', 'Please make sure that the password and the confirmation match.');
                return;
            } else if (this.strength < 60) {
                this.sweetAlert.error('Insecure', 'The given password is not secure enough');
                return;
            } else if (!this.model.current_password) {
                this.sweetAlert.error('Current password', 'Please enter your current password to change it');
                return;
            }
        }
        this.submitting = true;

        this.api.put(`auth/profile`, this.model).then((updateResponse) => {
            this.submitting = false;
            this.model = updateResponse;

            this.sweetAlert.success('Success', 'Changes have been saved successful');
            this.state.go('app.settings.profile-details').then(() => {
                setTimeout(() => {
                    location.reload();
                }, 800);
            });

        }, (e) => {
            this.submitting = false;
            this.errorHandler.default(e);
        });
    }

    cancel() {
        this.state.go('app.settings.profile-details');
    }

    _loadProfile() {
        this.loading = true;

        return this.api.get(`auth/profile?include=company`).then((response) => {
            this.loading = false;
            this.model = userModelReducer(response.data.data);
        }, (e) => {
            this.loading = false;
            this.errorHandler.default(e);
        });
    }
}

angular
    .module('festzelt-os.settings')
    .controller('ProfileEditCtrl', [
        '$rootScope',
        '$http',
        'Error',
        'SweetAlert',
        '$state',
        'ResourceCommon',
        ProfileEditController
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/profile-edit-controller.js